import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, Settings2, Layers, LineChart } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';

const SCADA_IMG = 'https://static.prod-images.emergentagent.com/jobs/2f8d28b7-4ebe-4317-8ba5-2c9c19007ec7/images/326e8635ebd579ea2acde3e8d88fe869df59e3f6d50505e4ce50d8b8091d0dc9.jpeg';

const SimShowcase = () => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const features = [
    { Icon: Settings2, title: L('تشغيل الأنظمة خطوة بخطوة', 'Run systems step by step'), desc: L('نفّذ سيناريوهات حقيقية وتعلّم من التطبيق العملي.', 'Run real scenarios and learn by doing.') },
    { Icon: Layers, title: L('التعلّم بالممارسة', 'Learn by practice'), desc: L('طبّق ما تتعلمه مباشرة داخل بيئة المحاكاة.', 'Apply what you learn right inside the simulation.') },
    { Icon: LineChart, title: L('مشاهدة النتائج مباشرة', 'See results instantly'), desc: L('راقب سلوك النظام واستنتج النتائج فوراً.', 'Watch the system behave and draw conclusions instantly.') },
  ];
  return (
    <section data-testid="home-sim-showcase" className="section-y">
      <div className="site-container">
        <div className="rounded-[28px] bg-gradient-to-br from-white via-blue-50/40 to-white border border-slate-200 shadow-sm p-5 sm:p-8 lg:p-10 grid lg:grid-cols-[1.25fr_1fr] gap-8 items-center">
          <div>
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-amber-100 text-amber-800 text-sm font-black mb-4"><Crown className="w-4 h-4" />{L('محاكاة تفاعلية', 'Interactive simulation')}</span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black text-slate-900 tracking-tight mb-3">
              <span className="text-blue-600">{L('محاكاة تفاعلية', 'Exclusive interactive')}</span> {L('حصرية لتعلّم الأتمتة', 'simulations to learn automation')}
            </h2>
            <p className="text-slate-600 text-sm sm:text-base leading-relaxed mb-6 max-w-2xl">{L('تدرّب على أنظمة الأتمتة الصناعية في بيئة محاكاة واقعية وآمنة، واكتسب المهارات العملية التي تحتاجها لسوق العمل.', 'Practise industrial automation systems in a realistic, safe simulation environment and gain the hands-on skills employers need.')}</p>
            <div className="grid sm:grid-cols-3 gap-3 mb-6">
              {features.map(f => (
                <div key={f.title} className="rounded-2xl bg-white border border-slate-200 p-4 text-center hover:-translate-y-1 hover:shadow-md transition-[transform,box-shadow]">
                  <f.Icon className="w-7 h-7 text-blue-600 mx-auto mb-2" />
                  <h3 className="font-black text-slate-900 text-sm sm:text-base mb-1">{f.title}</h3>
                  <p className="text-xs sm:text-sm text-slate-500 leading-relaxed">{f.desc}</p>
                </div>
              ))}
            </div>
            <Link to="/subscription" data-testid="home-sim-exclusive-cta" className="flex sm:inline-flex items-center justify-center gap-2 h-12 px-8 rounded-full bg-gradient-to-l from-blue-700 to-blue-600 text-white font-black shadow-lg shadow-blue-600/25 hover:from-blue-800 transition-colors">
              <Crown className="w-5 h-5 text-amber-300" />{L('هذه الميزة حصرية للمشتركين فقط', 'This feature is exclusive to subscribers')}
            </Link>
          </div>
          <img src={SCADA_IMG} alt={L('محاكاة نظام SCADA للتحكم بمستوى خزان', 'SCADA tank level simulation')} className="w-full rounded-3xl order-first lg:order-none" />
        </div>
      </div>
    </section>
  );
};

export default SimShowcase;
